/* unplugin-vue-components disabled */import script from "./IframeContainer.vue?vue&type=script&setup=true&lang=js"
export * from "./IframeContainer.vue?vue&type=script&setup=true&lang=js"

import "./IframeContainer.vue?vue&type=style&index=0&id=108dce7d&lang=scss"

const __exports__ = script;

export default __exports__